/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LISCaseListBlock = {
    readonly id?: number;
    /**
     * name of the block (1 in A1, 2 in A2, A in 1A (yosemite))
     */
    name: string | null;
    lis_state?: LISCaseListBlock.lis_state | null;
    /**
     * The number of sections from the specimen constituting the block that are inserted into the cassette.
     */
    piece_count?: LISCaseListBlock.piece_count | null;
    readonly specimen_id?: number;
}

export namespace LISCaseListBlock {

    export enum lis_state {
        UNPROCESSED = 'unprocessed',
        RACKED = 'racked',
        PROCESSED = 'processed',
        COOLING = 'cooling',
        EMBEDDED = 'embedded',
    }

    /**
     * The number of sections from the specimen constituting the block that are inserted into the cassette.
     */
    export enum piece_count {
        _0 = '0',
        _1 = '1',
        _2 = '2',
        _3 = '3',
        _4 = '4',
        _5 = '5',
        _1F = '1F',
        _2F = '2F',
        _3F = '3F',
        _4F = '4F',
        _5F = '5F',
        F = 'F',
    }


}
